import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import TextField from "material-ui/TextField";
import ImageCropper from "../../components/common/ImageCropper";
import NormalBigButton from "../../components/common/NormalBigButton";
import ActionButton from "../../components/common/ActionButton";
import TextButton from "../../components/common/TextButton";
import Padding from "../../components/common/Padding";
import InfoModal from "../../components/common/InfoModal";
import colors from "../../styles/colors";
import help from "../../documents/help";
import { FormControlLabel, Switch } from "@material-ui/core";

const style = {
  container: {
    display: "flex",
    marginLeft: "15%",
    marginRight: "15%",
    marginTop: 60,
    justifyContent: "center",
  },
  titleText: {
    textAlign: "center",
    fontSize: 26,
    color: colors.text,
    marginBottom: 20,
  },
  descText: {
    textAlign: "center",
    fontSize: 18,
    color: colors.text,
    marginBottom: 20,
  },
  navButtonsBar: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "space-around",
    marginTop: 40,
  },
  inputText: {
    fontSize: 30,
    color: colors.primary,
  },
  image: {
    height: 100,
  },
  centered: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};

class AppCreator extends Component {
  steps = [
    "appName",
    // "addDesc", //Hide app Description step because it is not being used.
    "authorName",
    "profession",
    "customize",
    "appType",
    "submit",
  ];

  defaultAppDescText =
    "Watch these personalized videos recorded by your own therapist to remember exactly what to do.";

  constructor(props) {
    super(props);

    this.state = {
      appInfo: { appDesc: this.defaultAppDescText },
      currentStep: 0,
      isPhysicalTherapist: true,
    };

    this.updateAppInfo = this.updateAppInfo.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.backStep = this.backStep.bind(this);
    this.jumpSteps = this.jumpSteps.bind(this);
    this.renderNavButtons = this.renderNavButtons.bind(this);

    this.renderStepAppName = this.renderStepAppName.bind(this);
    this.renderAddDesc = this.renderAddDesc.bind(this);
    this.renderAuthorName = this.renderAuthorName.bind(this);
    this.renderProfession = this.renderProfession.bind(this);
    this.renderCustomize = this.renderCustomize.bind(this);
    this.renderAppType = this.renderAppType.bind(this);
    this.renderSubmit = this.renderSubmit.bind(this);
  }

  updateAppInfo(name, value) {
    let appInfo = Object.assign({}, this.state.appInfo, {
      [name]: value,
    });

    this.setState({
      appInfo,
    });
    this.props.onChange(appInfo);
  }

  handleChange(event) {
    this.updateAppInfo(event.target.name, event.target.value);
  }

  renderSteps() {
    let step = this.steps[this.state.currentStep];
    return (
      <div>
        {this.renderStepAppName(step)}
        {this.renderAddDesc(step)}
        {this.renderAuthorName(step)}
        {this.renderProfession(step)}
        {this.renderCustomize(step)}
        {this.renderAppType(step)}
        {this.renderSubmit(step)}
      </div>
    );
  }

  backStep() {
    this.setState({ currentStep: this.state.currentStep - 1 });
  }
  nextStep() {
    const { currentStep } = this.state;

    // Only call chooseProfession when step is "profession"

    this.setState({ currentStep: currentStep + 1 });
  }

  jumpSteps(numSteps) {
    this.setState({ currentStep: this.state.currentStep + numSteps });
  }

  renderNavButtons(hasBack, hasNext, isNextDisabled) {
    return (
      <div style={style.navButtonsBar}>
        {hasBack && (
          <NormalBigButton label="Back" onClick={() => this.backStep()} />
        )}
        {hasNext && (
          <ActionButton
            label="Next"
            onClick={() => this.nextStep()}
            disabled={isNextDisabled}
          />
        )}
      </div>
    );
  }

  renderStepAppName(step) {
    return (
      <div>
        {step === "appName" && (
          <div>
            <div style={style.titleText}>
              {"What do you want to name your Channel?"}
            </div>
            <div style={style.descText}>
              {"The name of your clinic/company is most popular"}
            </div>
            <Padding height={20} />
            <div style={style.centered}>
              <TextField
                style={{ width: 400 }}
                inputStyle={style.inputText}
                hintText="Type your answer here..."
                name="appName"
                value={this.state.appInfo.appName}
                onChange={this.handleChange}
              />
            </div>
            {this.renderNavButtons(
              false,
              true,
              _.isEmpty(this.state.appInfo.appName)
            )}
          </div>
        )}
      </div>
    );
  }

  renderAddDesc(step) {
    return (
      <div>
        {step === "addDesc" && (
          <div>
            <div style={style.titleText}>
              {"Add a description of your Channel"}
            </div>
            <div style={style.centered}>
              <TextButton label="Skip" onClick={() => this.nextStep()} />
            </div>
            <Padding height={20} />
            <div style={style.centered}>
              <TextField
                fullWidth={true}
                hintText="ie. Your custom home treatment instructions for recovering from knee replacement surgery"
                name="appDesc"
                value={this.state.appInfo.appDesc}
                onChange={this.handleChange}
              />
            </div>
            {this.renderNavButtons(true, true)}
          </div>
        )}
      </div>
    );
  }
  componentDidMount() {
    // Set default templateId to 103 when the component is first rendered
    this.updateAppInfo("templateId", 103);
  }

  renderAuthorName(step) {
    return (
      <div>
        {step === "authorName" && (
          <div>
            <div style={style.titleText}>{"Provider"}</div>
            <Padding height={20} />
            <div style={style.centered}>
              <TextField
                style={{ width: 400 }}
                inputStyle={style.inputText}
                hintText="e.g. Dr. Jane Smith"
                name="author"
                value={this.state.appInfo.author}
                onChange={this.handleChange}
              />
            </div>
            {this.renderNavButtons(
              true,
              true,
              _.isEmpty(this.state.appInfo.author)
            )}
          </div>
        )}
      </div>
    );
  }

  renderProfession(step) {
    return (
      <div>
        {step === "profession" && (
          <div>
            <div style={style.titleText}>
              {
                "Do you give instructions that include Sets, Repetitions, Duration, Intensity and Frequency?"
              }
            </div>
            <Padding height={10} />
            <div style={style.centered}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isPhysicalTherapist}
                    onChange={(e) => {
                      const isPhysicalTherapist = e.target.checked;
                      this.setState({ isPhysicalTherapist });
                      // Just save selection — don't navigate yet
                      this.updateAppInfo(
                        "templateId",
                        isPhysicalTherapist ? 103 : 100
                      );
                    }}
                    color="primary"
                  />
                }
                label={null}
              />
              <div>
                <span style={{ marginRight: 10 }}>No</span>
                <span style={{ marginLeft: 10 }}>Yes</span>
              </div>
            </div>
            {this.renderNavButtons(true, true)}
          </div>
        )}
      </div>
    );
  }

  renderCustomize(step) {
    return (
      <div>
        {step === "customize" && (
          <div>
            <div style={style.titleText}>{"Extra Branding Features"}</div>
            <div style={style.centered}>
              <TextButton label="Skip" onClick={() => this.nextStep()} />
            </div>
            <Padding height={10} />
            <InfoModal content={help.coverImage()}>
              <div>{"Custom Channel Cover (420 x 600)"}</div>
            </InfoModal>
            <ImageCropper
              aspect={7 / 10}
              imageUrl={this.state.appInfo.coverUrl}
              userId={this.props.userId}
              previewStyle={style.image}
              handleSubmit={(imageUrl) => {
                this.updateAppInfo("coverUrl", imageUrl);
              }}
            />
            {this.renderNavButtons(true, false)}
          </div>
        )}
      </div>
    );
  }

  renderAppType(step) {
    let chooseAppType = (appType) => {
      this.updateAppInfo("appType", appType);
      this.nextStep();
    };
    return (
      <div>
        {step === "appType" && (
          <div>
            <div style={style.titleText}>{"Choose a type of Channel"}</div>
            <div style={style.descText}>
              {
                "If this Channel app will be customized for each patient/client, please choose:"
              }
            </div>
            <div style={style.centered}>
              <TextButton
                buttonWidth={400}
                label="Standard"
                onClick={() => chooseAppType("Standard")}
              />
            </div>
            <Padding height={20} />
            <div style={style.descText}>
              {
                "If this Channel app will provide general instructions, please choose:"
              }
            </div>
            <div style={style.centered}>
              <TextButton
                buttonWidth={400}
                label="Library Only"
                onClick={() => chooseAppType("LibraryOnly")}
              />
            </div>
            {this.renderNavButtons(true, false)}
          </div>
        )}
      </div>
    );
  }

  renderSubmit(step) {
    return (
      <div>
        {step === "submit" && (
          <div>
            <div style={style.titleText}>{"Ready to create the Channel?"}</div>
            {this.renderNavButtons(true)}

            <div style={style.navButtonsBar}>
              <ActionButton
                label="Create"
                onClick={() => this.props.onSubmit()}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    return <div style={style.container}>{this.renderSteps()}</div>;
  }
}

AppCreator.propTypes = {
  onChange: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  isOrgMember: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

export default AppCreator;



// WEBPACK FOOTER //
// ./src/layout/playbook/AppCreator.js